import BroadcastMessageForm from './BroadcastMessageForm.component';

export default BroadcastMessageForm;